import { compile } from "vue";
import { mapState } from "vuex";
import { defineAsyncComponent } from 'vue';
// import ShortUniqueId from 'short-unique-id'; FIXME Disbled for now

export default {
    props: {
        secondary: { type: Boolean, },
        recursive: { type: Boolean, default: false },
        mitt:      { type: String },
        dispatch:  { type: String },
        take:      { type: String },
        mtake:     { type: String },
        give:      { type: String },
        mgive:     { type: String },
        config:    { type: Object },
        params:    { type: Object },
        keep:      { type: Object },
        attrs:     { type: Object, default() { return {} }},
        mq:    { type: String },
        lvl:   { type: String },
    },
    data(){ return {
        configReady: false,
        translateReady: false,
        unroll: false,
        ready: false,
        results: [],
        timer: 300,
        icons_lvl: {
            notify: "question",
            success: "check",
            alert: "exclamation",
            warning: "exclamation-triangle",
        },
        messages: {
            cancel: "Operation canceled due to new request.",
            unknown: "Error unknown, you can call the support",
            areyousure: "Are you sure to do this?",
        },
    }},
    components: {
        OctoloItem: defineAsyncComponent(() => import("@/toremove/components/octolo/items/Item.vue")),
        OctoloButton: defineAsyncComponent(() => import("@/toremove/components/octolo/button/Button.vue")),
        OctoloMessage: defineAsyncComponent(() => import("@/toremove/components/octolo/message/Message.vue")),
        OctoloForm: defineAsyncComponent(() => import("@/toremove/components/octolo/forms/Form.vue")),
        ValidCancel: defineAsyncComponent(() => import("@/toremove/components/octolo/utils/ValidCancel.vue")),
        Box: defineAsyncComponent(() => import("@/toremove/components/octolo/utils/Box.vue")),
    },
    computed: {
        ...mapState('App', ['images']),
        cssTheme(){ return this.isAuthenticated ? this.profile.style : "light" },
        isHomeView(){ return (this.$route.name == 'app-home') },
    },
    methods: {
        // UTILS
        has: obj => (obj && Object.keys(obj).length),
        hasKey(obj, key ) { return Object.keys(obj).includes(key);},
        hasMethod(method){ return (typeof this[method] === "function"); },
        compileTemplate(template, data) { return Object.assign({}, compile(template), {data() { return data }}); },
        errorMsg(code){ return this._tr('errors.' + code, code); },
        // getShortUid(){ return new ShortUniqueId()(); }, #FIXME Disbled for now
        addStr(add, to){ return to.includes(add) ? to : to + " " + add; },
        removeStr(remove, to){ return to.includes(remove) ? to.replace(remove, "") : to; },
        toParams({name, params, query, props}){
            params = params !== undefined ? params : {};
            query  = query  !== undefined ? query  : {};
            props  = props  !== undefined ? props  : {};
            params.companyUid = this.$group_named_id;
            return { name: name, params: params, query: query, props: props };
        },
        actionClearable(action, payload) {
            clearTimeout(this.awaiting);
            this.awaiting = setTimeout(() => {
                if(payload)
                    this[action](payload);
                else
                    this[action]();
            },
            300);
        },
        getDescendantVal(desc, obj, ifnull) {
            var objc = obj, arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            if(obj === undefined && ifnull) {
                ifnull.forEach(element => {
                    if(!obj) obj = this.getDescendantVal(objc, element+"."+desc);
                });
            }
            return obj;
        },

        // CHILD-TO-PARENT
        hatch()  { return this.recursive ? this.give : ''; },
        mhatch() { return this.recursive ? this.mgive : 'giveIt'; },
        hasToDoIt() { return (this.action || this.dispatch) },
        takeIt(){
            if(this.take) return this.$parent[this.take];
            if(this.mtake) this.$parent[this.mtake]();
        },
        defaultGive(data){
            return this.keep ? {data: data, keep: this.keep} : data;
        },
        giveIt(data) {
            if(this.keep && (this.mitt || this.give || this.mgive)) {
                if(this.mitt) this.emitter.emit(this.mitt, {data: data, keep: this.keep});
                if(this.give) this.$parent[this.give] = {data: data, keep: this.keep};
                if(this.mgive) this.$parent[this.mgive]({data: data, keep: this.keep});
            } else if(this.mitt || this.give || this.mgive) {
                if(this.mitt) this.emitter.emit(this.mitt, data);
                if(this.give) this.$parent[this.give] = data;
                if(this.mgive) this.$parent[this.mgive](data);
            }else{
                this.defaultGive(data);
            }
        },
        async doIt(payload) {
            payload = payload !== undefined ? payload : undefined;
            var keep = this.keep;
            if(keep){
                if(this.mitt) this.emitter.emit(this.mitt, {payload, keep});
                if(this.action) return this.$parent[this.action]({ payload, keep });
                if(this.dispatch) return await this.$store.dispatch(this.dispatch, { payload, keep });
            }else{
                if(this.mitt) this.emitter.emit(this.mitt, payload);
                if(this.action) return this.$parent[this.action](payload);
                if(this.dispatch) return await this.$store.dispatch(this.dispatch, payload);
            }
        },

        // VISUEL
        getSmth(smth){ return this[smth] ? smth + this[smth] : ''; },
        getCaret(test){ return test ? "caret-up" : "caret-down"; },
        imageUrl(url){ return "background-image: url('"+url+"')"; },
        image_url(url){ return "background-image: url('"+url+"')"; },
        doRoll(){ this.unroll = !this.unroll; },
        doUnroll(){ this.unroll = false; },
        // dateTimeReadable(date){ return this.$dayjs(date).format('dddd Do MMMM YYYY à HH:mm'); },
        // dateReadable(date){ return this.$dayjs(date).format('dddd Do MMMM YYYY'); },
        // parseDateTimeLong(date){ return this.$dayjs(date).format("dddd DD MMMM YYYY à HH:mm"); },
        // parseDateLong(date){ return this.$dayjs(date).format("dddd DD MMMM YYYY"); },
        // parseDateTimeShort(date){ return this.$dayjs(date).format("DD-MM-YYYY HH:mm"); },
        // parseDateTimeShortSlash(date){ return this.$dayjs(date).format("DD/MM/YYYY HH:mm"); },
        // parseDateTimeMix(date){ return this.$dayjs(date).format("DD MMM YYYY HH:mm"); },
        // parseDateMix(date){ return this.$dayjs(date).format("DD MMM YYYY"); },
        // parseDateShort(date){ return this.$dayjs(date).format("DD-MM-YYYY"); },
        // parseDateShortSlash(date){ return this.$dayjs(date).format("DD/MM/YYYY"); },
        // parseDateTimeShortEN(date){ return this.$dayjs(date).format("YYYY-MM-DD HH:mm"); },
        // parseDateShortEN(date){ return this.$dayjs(date).format("YYYY-MM-DD"); },
        // parseTime(date){ return this.$dayjs(date).format("HH:mm")+"tata"; },
        dateTimeReadble(date) {return date},
        dateReadable(date) {return date},
        parseDateTimeLong(date) {return date},
        parseDateLong(date) {return date},
        parseDateTimeShort(date) {return date},
        parseDateTimeMix(date) {return date},
        parseDateMix(date) {return date},
        parseDateShort(date) {return date},
        parseDateTimeShortEN(date) {return date},
        parseDateShortEN(date) {return date},
        parseTime(date) {return date},
        numberReadable(number){ return String(number).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' '); },
        iconLvl(lvl) { return this.hasKey(this.icons_lvl, lvl) ? this.icons_lvl[lvl] : "info"; },

        // A SUPPRIMER
        thisContext(){ return this; },
        setAppName(name){ this.appName = name; },
        bindAttr() { return this.attrs; },
        getLvl() { return this.lvl },
        baseClass() { return [this.mq, this.getLvl(),]; },
    },
}
